export default __webpack_public_path__ + "static/end-points-dont-992b762a8a8c40e5f5c6cb838ecdc20f.png";